module.exports = " <li :class=classes> {{ data.label }} <i v-if=showArrow :class=\"[PRE + '-icon',PRE + '-icon-ios-arrow-right']\"></i> <i v-if=showLoading :class=\"[PRE + '-icon',PRE + '-icon-load-c',PRE + '-load-loop']\"></i> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/standard/components/cascader/casitem.vue
// module id = 293
// module chunks = 0